import { render, staticRenderFns } from "./CreateComment.vue?vue&type=template&id=518b1bea&scoped=true"
import script from "./CreateComment.vue?vue&type=script&lang=js"
export * from "./CreateComment.vue?vue&type=script&lang=js"
import style0 from "./CreateComment.vue?vue&type=style&index=0&id=518b1bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b1bea",
  null
  
)

export default component.exports